/**
 * Router Service
 *
 * Provides navigation capabilities using React Router.
 * This module stores a reference to the router that can be used outside of React components.
 */

import type { NavigateFunction } from "react-router-dom";

// Store the navigate function set by the app
let navigateRef: NavigateFunction | null = null;

// Set the navigate function (called from AppLayout or similar)
export const setNavigate = (navigate: NavigateFunction) => {
  navigateRef = navigate;
};

export const router = {
  back: () => {
    if (navigateRef) {
      navigateRef(-1);
    } else {
      window.history.back();
    }
  },
  goBack: () => {
    if (navigateRef) {
      navigateRef(-1);
    } else {
      window.history.back();
    }
  },
  navigate: (path: string, options?: { replace?: boolean; state?: any }) => {
    if (navigateRef) {
      navigateRef(path, options);
    } else {
      // Fallback to window.location for cases where router isn't initialized
      if (options?.replace) {
        window.location.replace(path);
      } else {
        window.location.href = path;
      }
    }
  },
};

// Helper to get navigate function directly
export const getSafeRouter = () => navigateRef;

export default router;
